"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");

var Closure = function () {
    function Closure(node, enclosingScope, id) {
        _classCallCheck(this, Closure);

        this.node = node;
        this.enclosingScope = enclosingScope;
        this.id = id;
    }

    _createClass(Closure, [{
        key: "createScope",
        value: function createScope(args) {
            var environment = this.node.params.reduce(function (s, p, idx) {
                return s.set(p.name, args[idx]);
            }, immutable_1.Map());
            return {
                name: this.getScopeName(args),
                parent: this.enclosingScope,
                environment: environment
            };
        }
    }, {
        key: "getScopeName",
        value: function getScopeName(args) {
            var name = this.name + "(";
            args.forEach(function (arg, idx) {
                if (arg instanceof Closure) {
                    name += arg.name;
                } else {
                    name += arg.toString();
                }
                if (idx < args.length - 1) {
                    name += ', ';
                }
            });
            name += ')';
            return name;
        }
    }, {
        key: "name",
        get: function get() {
            return this.node.id ? this.node.id.name : "<lambda-" + this.id + ">";
        }
    }]);

    return Closure;
}();

exports.default = Closure;
//# sourceMappingURL=Closure.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/Closure.js
// module id = 78
// module chunks = 3